import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { getTrans as T } from "../../../Shared/Language";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  AddArticle,
  getArticle,
} from "./Services/ArticleDiscussionBoardService";
import { getRawSystemAlertsArray } from "../../../Routes/AuthGard/usePermissions";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
import { Editor } from "primereact/editor";
import { debounce } from "lodash";

const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);

function ArticleAddEdit() {
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [articleList, setArticleList] = useState([]);
  const toster = useContext(TostMsg);
  const { articleId, Archived } = useParams();
  const [loading, setLoading] = useState(false);
  const [articleImageList, setArticleImageList] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState([]);
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [acceptRatio, setAcceptRatio] = useState(0);
  const history = useHistory();
  const SystemAlerts = getRawSystemAlertsArray();
  const CorruptImage = "/images/no-data-found/feed_dummy.png";

  // Local state for Editor
  const [editorValue, setEditorValue] = useState("");

  const ArticleValidation = Yup.object().shape({
    Summary: Yup.string().required("Description is required."),
    Title: Yup.string().required("Title is required."),
    image: Yup.string().nullable(),
    groupRefrenceId: Yup.string(),
  });

  const ArticleForm = useFormik({
    initialValues: {
      Title: "",
      Summary: "",
      Image: "",
      groupRefrenceId: "",
    },
    validationSchema: ArticleValidation,
    onSubmit: async (data) => {
      let articleIdFinel;
      setLoading(true);
      let ArticleMedia = [];
      const ImagePath = data.Image ? data.Image.split(",") : [];

      if (ImagePath.length > 0) {
        const existingMedia = articleImageList?.map((item) => item.Media) || [];
        const newImages = ImagePath.filter(
          (url) => !existingMedia.includes(url)
        );
        const newImageObjects = newImages.map((url, index) => ({
          ArticleId: 0,
          Media: url,
          MediaType: "image",
          MediaThumbnail: url,
          Id: index,
        }));

        if (newImageObjects.length > 0) {
          ArticleMedia = [...(articleImageList || []), ...newImageObjects];
        } else if (articleImageList?.length > 0) {
          ArticleMedia = articleImageList;
        } else {
          ArticleMedia = ImagePath.map((imagePath, index) => ({
            Id: index,
            ArticleId: 0,
            Media: imagePath,
            MediaType: "image",
            MediaThumbnail: imagePath,
          }));
        }
      }

      if (articleId) {
        articleIdFinel = articleList?.Id;
      }

      const body = {
        Id: articleIdFinel ?? 0,
        EmpId: userDetails?.EmpId,
        WriterPenName: userDetails?.FullName,
        Title: data.Title,
        Summary: data.Summary,
        GroupId: data?.groupRefrenceId ? Number(data.groupRefrenceId) : 0,
        DocumentPath: "",
        ArticleMedia,
      };

      try {
        await AddArticle(body);
        setLoading(false);
        if (articleId) {
          GetMasterSystemAlertList("Article_Updated_Successfully", 0);
        } else {
          GetMasterSystemAlertList("Article_Created_Successfully", 0);
        }
        setTimeout(() => {
          history.push("/Articles");
        }, 1000);
      } catch (err) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  useEffect(() => {
    // Sync editorValue with ArticleForm.values.Summary
    setEditorValue(ArticleForm.values.Summary || "");
  }, [ArticleForm.values.Summary]);

  const handleEditorChange = useCallback(
    debounce((value) => {
      setEditorValue(value);
      ArticleForm.setFieldValue("Summary", value);
    }, 300),
    [ArticleForm.setFieldValue] // Stable dependency
  );

  useEffect(() => {
    getArticleGroup();
    if (articleId) {
      GetArticleList();
    } else {
      ArticleForm.resetForm();
      setEditorValue("");
    }
  }, [articleId, Archived]); // Include dependencies

  const getArticleGroup = async () => {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "ArticleGroup",
    };
    try {
      const data = await GetMasterTypeData(params);
      setSelectedArticle(data?.Data || []);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  };

  async function GetArticleList() {
    setLoading(true);
    const params = {
      LoggedInUserId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
      articleByGUID: articleId,
      articleId: 0,
      Search: "",
      articleById: 0,
      IsFeatured: 0,
      IsArchived: Number(Archived),
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      const response = await getArticle(params);
      setLoading(false);
      const ArticleData = response?.Data?.orgArticles[0];
      setArticleList(ArticleData || {});
      setArticleImageList(ArticleData?.ArticleMedia || []);
      const imageURL =
        ArticleData?.ArticleMedia?.map((media) => media.Media).join(",") || "";

      const articleFormValues = {
        Title: ArticleData?.Title || "",
        Summary: ArticleData?.Summary || "",
        Image: imageURL,
        groupRefrenceId: ArticleData?.GroupId || "",
      };
      ArticleForm.setValues(articleFormValues);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.ArticleData);
    }
  }

  const GetMasterSystemAlertList = useCallback((message, type) => {
    SystemAlerts?.forEach((msg) => {
      if (msg?.Name === message && type === 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  const fileInputRef = useRef(null);
  const openFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setShowCropper(true);
      setAcceptRatio(3.19 / 1);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const handleCropComplete = (croppedBlob) => {
    uploadPolicyDocFile([
      new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" }),
    ]);
  };
  const [imageIze, setImageIze] = useState([]);
  async function uploadPolicyDocFile(file) {
    setLoading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      const params = {
        UploadType: UploadFile_KEYS?.Article,
        RefId: articleList?.Id ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const ImageURL = response?.Data;
        if (!ImageURL || !Array.isArray(ImageURL)) {
          throw new Error("Invalid image data");
        }
        const existingImages = ArticleForm.values.Image || "";
        const existingImageArray = existingImages
          ? existingImages.split(",")
          : [];
        const updatedImages = [...existingImageArray, ...ImageURL];
        setImageIze(updatedImages);
        ArticleForm.setFieldValue("Image", updatedImages.join(","));
      } catch (error) {
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setLoading(false);
      }
    } else {
      toster.current.warn("No file selected.");
      setLoading(false);
    }
  }

  const handleDeleteImage = (image) => {
    const documentValue = ArticleForm?.values?.Image || "";
    const fileData = documentValue.split(",");
    const updatedData = fileData.filter((doc) => doc !== image);
    const filteredList = articleImageList.filter(
      (item) => item.Media !== image
    );
    setArticleImageList(filteredList);
    setImageIze(updatedData);
    ArticleForm.setFieldValue("Image", updatedData.join(","));
  };

  const handleImageError = useCallback((event) => {
    event.target.src = CorruptImage;
  }, []);

    const headerTemplate = (
    <span className="ql-formats">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link href="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>

      <div className="container-fluid position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row">
                <div className="col-md-9 shrink-w">
                  <div className="form-head d-flex flex-wrap align-items-center mb-4">
                    <div className="me-auto">
                      {articleId ? (
                        <h2 className="font-w600 mb-0">
                          {T("Edit Article & Description")}
                        </h2>
                      ) : (
                        <h2 className="font-w600 mb-0">{T("Add Article")}</h2>
                      )}
                    </div>
                    <div className="rightside-tabs">
                      <Link to="/Articles">
                        <button className="back-newticket w-auto float-right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-left-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>{" "}
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>
                  <form onSubmit={ArticleForm.handleSubmit}>
                    <div className="row">
                      <div className="col-xl-8">
                        <div className="employee-card tile-grid tile-grid-v1">
                          <div id="feed-post-1" className="AnnouncementForm">
                            <div className="third-section">
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Title
                                  </label>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-sticky-note-o"
                                      aria-hidden="true"
                                    ></i>
                                    <input
                                      type="text"
                                      className={
                                        "form-control" +
                                        (ArticleForm.errors.Title &&
                                        ArticleForm.touched.Title
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={ArticleForm.handleChange}
                                      value={ArticleForm.values.Title}
                                      placeholder="Title"
                                      name="Title"
                                    />
                                  </div>
                                  <div
                                    className="invalid-feedback"
                                    style={{ marginLeft: "30px" }}
                                  >
                                    {ArticleForm.errors.Title &&
                                    ArticleForm.touched.Title
                                      ? ArticleForm.errors.Title
                                      : null}
                                  </div>
                                </div>
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Category
                                  </label>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-group"
                                      aria-hidden="true"
                                    ></i>
                                    <Dropdown
                                      value={
                                        ArticleForm?.values?.groupRefrenceId
                                      }
                                      onChange={(e) => {
                                        ArticleForm.setFieldValue(
                                          "groupRefrenceId",
                                          e.value
                                        );
                                      }}
                                      options={selectedArticle}
                                      className="filledannoucement"
                                      optionLabel="Name"
                                      optionValue="Id"
                                      placeholder="Choose..."
                                      checkmark={true}
                                      highlightOnSelect={false}
                                    />
                                  </div>
                                </div>
                                <div className="mb-4 col-md-12">
                                  <label className="form-label-file">
                                    Description
                                  </label>
                                  <div className="bg-white w-100">
                                    <Editor
                                      name="Summary"
                                      value={editorValue}
                                      onTextChange={(e) =>
                                        handleEditorChange(e?.htmlValue || "")
                                      }
                                      style={{ height: "320px" }}
                                      
                                      headerTemplate={headerTemplate}
                                      onBlur={() => {
                                        ArticleForm.setFieldValue(
                                          "Summary",
                                          editorValue
                                        );
                                        ArticleForm.setFieldTouched(
                                          "Summary",
                                          true
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {ArticleForm.errors.Summary &&
                                    ArticleForm.touched.Summary
                                      ? ArticleForm.errors.Summary
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="row">
                          <label className="form-label-file">
                            Article Image
                          </label>
                          {ArticleForm.values.Image?.length > 0 ? (
                            ArticleForm.values.Image.split(",").map((image) => (
                              <div key={image} className="">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="loadresumes">
                                      <span
                                        className="closeresume"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDeleteImage(image)}
                                        title="Delete"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-x"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                        </svg>
                                      </span>
                                      <div className="inner">
                                        <img
                                          src={image}
                                          className="w-100"
                                          alt="Article Image"
                                          onError={handleImageError}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="col-xl-6">
                              <div className="card">
                                <div className="card-body">
                                  <div className="loadresumes">
                                    <div className="inner">
                                      <img
                                        src="/images/org-img/learn/add.png"
                                        className="w-100"
                                        alt="Add Image"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="invalid-feedback">
                            {ArticleForm.errors.Image &&
                            ArticleForm.touched.Image
                              ? ArticleForm.errors.Image
                              : null}
                          </div>
                          {showCropper && imageSrc && (
                            <ImageCropperModal
                              image={imageSrc}
                              onCropComplete={handleCropComplete}
                              onClose={() => setShowCropper(false)}
                              acceptRatio={acceptRatio}
                            />
                          )}
                          {imageIze.length < 5 && (
                            <div className="loadfiles">
                              <label
                                htmlFor="file-upload"
                                className="custom-file-upload"
                              >
                                <svg
                                  onClick={openFileInput}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="bi bi-paperclip"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                </svg>
                                Upload Images
                              </label>
                              <input
                                type="file"
                                id="file-upload"
                                multiple={true}
                                className="form-control"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                name="BannerImage"
                                accept="image/png, image/gif, image/jpeg"
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="btns-grp">
                          <Link to="/Articles">
                            <button
                              className="cancelbtn-click"
                              fdprocessedid="5mw059"
                            >
                              Cancel
                            </button>
                          </Link>
                          <button
                            type="submit"
                            className="savebtn-click"
                            fdprocessedid="jjj57m"
                          >
                            {articleId ? "Update" : "Post"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : null}
      </div>
    </>
  );
}

export default ArticleAddEdit;
